class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ThatRenoStore — auto-open the cart drawer after custom AJAX add-to-cart.
   Dawn's product-form.js already opens the drawer on its own. Custom sections
   (e.g. the trs-trending quick-view) POST to /cart/add.js directly and bypass
   it, so this hook catches those and renders + opens the drawer. */
(function () {
  if (window.__trsCartDrawerHook) return;
  window.__trsCartDrawerHook = true;

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch(input, init);
    if (url.indexOf('/cart/add') === -1) return promise;

    return promise.then(function (response) {
      if (!response.ok) return response;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return response;

      response
        .clone()
        .json()
        .then(function (data) {
          if (data && data.sections) return;
          return nativeFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              var openDialog = document.querySelector('dialog[open]');
              if (openDialog && openDialog.close) openDialog.close();
              drawer.classList.remove('is-empty');
              drawer.renderContents({ sections: sections });
            });
        })
        .catch(function () {});

      return response;
    });
  };
})();

/* ThatRenoStore — "+ Add" buttons in the in-drawer "Often Paired With" carousel.
   Lives here rather than in snippets/trs-cart-pairing.liquid because that markup is
   re-injected via innerHTML on every cart update, and innerHTML-inserted <script>
   never executes — so a handler defined there would be dead whenever the cart
   started empty on page load. Delegated on document, so it survives every re-render.
   The add itself is picked up by the fetch hook above, which refreshes and reopens
   the drawer, so the customer never leaves the panel. */
document.addEventListener('click', function (event) {
  var btn = event.target && event.target.closest && event.target.closest('[data-trs-cp-add]');
  if (!btn || btn.disabled) return;

  event.preventDefault();
  var id = btn.getAttribute('data-variant-id');
  if (!id) return;

  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: Number(id), quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-default-label') || '+ Add';
    });
});

/* ThatRenoStore — dismissable "Often Paired With" carousel, 12-08-2026.
   Same constraint as the handler above: the markup is re-injected on every cart
   update, so the dismissed state cannot live on the carousel itself. It goes on
   <html> plus sessionStorage, which survives every re-render, and the click is
   delegated on document. Dismissal lasts for the browsing session only. */
(function () {
  var KEY = 'trs:cp:dismissed';
  try {
    if (sessionStorage.getItem(KEY)) document.documentElement.classList.add('trs-cp-hidden');
  } catch (e) {}

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-trs-cp-close]');
    if (!btn) return;
    event.preventDefault();
    document.documentElement.classList.add('trs-cp-hidden');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  });
})();